import { FireAndFlowerOldStylePrintCardMenu } from './fire-and-flower-old-style-print-card-menu';

export class FireAndFlowerMemberPrintCardMenu extends FireAndFlowerOldStylePrintCardMenu {}
